// lib/ilhaNav.js — ILHA DE NAVEGAÇÃO desktop (port do #func-bottom-nav mobile).
// Protótipo aprovado 04/07: prototipos/wirekit-liquidglass-ilha.html
//
// Arquitetura de navegação (decisão 04/07):
//   clique no grupo  → última página usada do grupo (ou a primeira)
//   hover 300ms / botão-direito → POPOVER (stack) com as entradas do grupo
//   ⊞ ou Ctrl+K      → LAUNCHER com todos os módulos + busca
//   dentro do módulo → abas/segmented da casca (não é papel da ilha)
// Reativa: .mini no scroll ↓ (padding 9→6, botão 48→40), volta no ↑ (padrão mobile).
// Fonte de verdade = NAV_GROUPS_ADMIN + filterNavGroups (mesma da sidebar).
// ⚠️ backdrop-filter ANINHADO não funciona (backdrop root) → popover/launcher
//    ficam FORA da ilha, position:fixed (gotcha documentado na retomada 04/07).

import { NAV_GROUPS_ADMIN } from '../components/sidebar.js';
import { filterNavGroups } from './permissions.js';
import { Icons } from './icons.js';
import { esc } from './dom.js';
import { navigate, getCurrentRoute } from '../router/router.js';

const STYLE_ID = 'ilha-nav-style';
const REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
const REC_KEY = 'angular-ilha-rec';

const CSS = `
:root{
  --ilha-bg: var(--glass, rgba(17,20,28,.5));
  --ilha-border: var(--glass-border, rgba(255,255,255,.14));
  --ilha-ic: var(--text2, rgba(255,255,255,.58));
  --ilha-ic-on: var(--text, #fff);
  --ilha-hl: rgba(255,255,255,.12);
  --ilha-pop-bg: color-mix(in srgb, var(--bg-deep, #0a0a0f) 38%, transparent);
  --ilha-z: 920;
}
html.light{ --ilha-hl: rgba(20,20,28,.10); }
.ilha-wrap{position:fixed;left:0;right:0;bottom:16px;display:flex;justify-content:center;pointer-events:none;z-index:var(--ilha-z)}
.ilha{pointer-events:auto;position:relative;display:flex;align-items:center;gap:3px;padding:9px;border-radius:32px;
  background:var(--ilha-bg);border:1px solid var(--ilha-border);
  -webkit-backdrop-filter:blur(20px) saturate(150%);backdrop-filter:blur(20px) saturate(150%);
  transition:padding .25s ease}
html.light .ilha{box-shadow:0 6px 24px rgba(20,20,28,.14)}
.ilha.mini{padding:6px}
.ilha-btn{position:relative;width:56px;height:48px;display:flex;align-items:center;justify-content:center;
  background:transparent;border:0;outline:none;cursor:pointer;border-radius:24px;color:var(--ilha-ic);z-index:1;
  transition:transform .12s ease,color .2s,background-color .2s,width .25s,height .25s}
.ilha.mini .ilha-btn{height:40px}
.ilha-btn svg{width:21px;height:21px;pointer-events:none;transition:width .25s,height .25s}
.ilha.mini .ilha-btn svg{width:18px;height:18px}
.ilha-btn:hover{color:var(--ilha-ic-on)}
.ilha-btn.on{color:var(--sc-info)}
.ilha-btn:active{transform:scale(.93)}
.ilha-btn:focus-visible{outline:2px solid var(--sc-info);outline-offset:2px}
.ilha-hl{position:absolute;top:9px;bottom:9px;left:0;width:0;border-radius:24px;background:var(--ilha-hl);pointer-events:none;z-index:0;
  transition:transform .32s cubic-bezier(.34,1.4,.5,1),width .32s cubic-bezier(.34,1.4,.5,1),top .25s ease,bottom .25s ease}
.ilha.mini .ilha-hl{top:6px;bottom:6px}
.ilha-sep{width:1px;height:26px;background:var(--ilha-border);margin:0 4px;flex-shrink:0}
.ilha-bdg{position:absolute;top:1px;right:7px;min-width:15px;height:15px;padding:0 4px;border-radius:8px;background:var(--red,var(--sc-bad));
  color:#fff;font-size:9.5px;font-weight:600;display:flex;align-items:center;justify-content:center;line-height:1;z-index:2}
.ilha-tip{position:absolute;bottom:calc(100% + 12px);left:50%;transform:translate(-50%,6px) scale(.96);white-space:nowrap;
  font:500 12px var(--font-sans);color:var(--text);background:var(--card);border:1px solid var(--border);border-radius:999px;padding:5px 11px;
  opacity:0;transition:opacity .15s,transform .15s;pointer-events:none}
.ilha-btn:hover .ilha-tip{opacity:1;transform:translate(-50%,0) scale(1)}
.ilha.pop-open .ilha-tip{opacity:0!important}
@keyframes ilha-pop{0%{transform:scale(1)}28%{transform:scale(.92)}62%{transform:scale(1.05)}100%{transform:scale(1)}}
.ilha-btn.pop{animation:ilha-pop .28s cubic-bezier(.34,1.5,.5,1)}
/* popover (stack) — FIXED, fora da ilha */
.ilha-pop-menu{position:fixed;min-width:224px;border-radius:18px;padding:8px;z-index:calc(var(--ilha-z) + 1);
  background:var(--ilha-pop-bg, rgba(16,18,26,.38));border:1px solid var(--ilha-border);
  -webkit-backdrop-filter:blur(32px) saturate(160%) brightness(.9);backdrop-filter:blur(32px) saturate(160%) brightness(.9);
  box-shadow:0 16px 40px rgba(0,0,0,.35);opacity:0;transform:translateY(8px) scale(.97);pointer-events:none;
  transition:opacity .18s,transform .18s cubic-bezier(.34,1.3,.5,1)}
html.light .ilha-pop-menu{background:rgba(255,255,255,.7)}
.ilha-pop-menu.open{opacity:1;transform:translateY(0) scale(1);pointer-events:auto}
.ilha-pop-menu .ph{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:7px 10px 6px;font:600 12px var(--font-sans);color:var(--text)}
.ilha-pop-menu .ph .all{font:500 11px var(--font-sans);color:var(--sc-info);cursor:pointer;background:none;border:0;padding:2px 4px;border-radius:6px}
.ilha-pop-menu .ph .all:hover{background:color-mix(in oklab, var(--sc-info) 16%, transparent)}
.ilha-pop-menu .pi{display:flex;align-items:center;gap:10px;width:100%;padding:8px 10px;border-radius:11px;border:0;
  background:transparent;color:var(--text2);font:500 13px var(--font-sans);cursor:pointer;text-align:left}
.ilha-pop-menu .pi:hover{background:var(--ilha-hl);color:var(--text)}
.ilha-pop-menu .pi:focus-visible{outline:2px solid var(--sc-info);outline-offset:1px}
.ilha-pop-menu .pi svg{width:16px;height:16px;flex-shrink:0;color:var(--text3)}
.ilha-pop-menu .pi:hover svg{color:var(--sc-info)}
.ilha-pop-menu .pi .rec{margin-left:auto;font:400 10.5px var(--font-sans);color:var(--text-muted)}
/* preferência de navegação: 'ilha' esconde a sidebar e devolve o espaço */
body.nav-sem-sidebar .app-sidebar{display:none!important}
body.nav-sem-sidebar #main-content, body.nav-sem-sidebar .app-main{margin-left:0!important}

/* espaço pro conteúdo não morrer atrás da ilha */
body.ilha-on #main-content{padding-bottom:104px !important}
@media (max-width:760px){ .ilha-wrap{display:none} }
@media (prefers-reduced-motion: reduce){ .ilha-tip,.ilha-pop-menu{transition:none} }
`;

function _rec(gid, page) {
  try {
    const m = JSON.parse(localStorage.getItem(REC_KEY) || '{}');
    if (page === undefined) return m[gid];
    m[gid] = page; localStorage.setItem(REC_KEY, JSON.stringify(m));
  } catch (_) { return undefined; }
}
function _ico(name) { return Icons[name] ? Icons[name]('sm') : ''; }

let _state = null;

export function mountIlha() {
  if (_state) return _state;
  if (!document.getElementById(STYLE_ID)) {
    const st = document.createElement('style'); st.id = STYLE_ID; st.textContent = CSS;
    document.head.appendChild(st);
  }
  const groups = filterNavGroups(NAV_GROUPS_ADMIN);
  if (!groups.length) return null;

  const wrap = document.createElement('div'); wrap.className = 'ilha-wrap';
  const ilha = document.createElement('nav'); ilha.className = 'ilha'; ilha.setAttribute('aria-label', 'Navegação');
  const mkBtn = (cls, tip, inner, attrs = '') =>
    `<button class="ilha-btn ${cls}" ${attrs}><span class="ilha-tip">${esc(tip)}</span>${inner}</button>`;
  ilha.innerHTML =
    mkBtn('', 'Buscar e navegar · Ctrl+K', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>', 'data-apps="1" aria-haspopup="dialog"') +
    '<span class="ilha-sep" role="separator"></span>' +
    groups.map((g) => mkBtn('', g.label, _ico(g.icon), `data-group="${g.id}" aria-haspopup="menu"`)).join('') +
    '<span class="ilha-hl"></span>';
  wrap.appendChild(ilha);
  document.body.appendChild(wrap);
  document.body.classList.add('ilha-on');

  // popover + launcher (FORA da ilha — backdrop root)
  const pop = document.createElement('div'); pop.className = 'ilha-pop-menu'; pop.setAttribute('role', 'menu');
  document.body.appendChild(pop);
  const hl = ilha.querySelector('.ilha-hl');
  const btns = [...ilha.querySelectorAll('.ilha-btn')];
  const groupBtn = (gid) => btns.find((b) => b.dataset.group === gid);
  const groupOf = (page) => groups.find((g) => g.items.some((i) => i.page === page));

  function placeHl(btn) {
    if (!btn) { hl.style.width = '0'; return; }
    hl.style.width = btn.offsetWidth + 'px';
    hl.style.transform = 'translateX(' + btn.offsetLeft + 'px)';
  }
  function syncActive() {
    const { page } = getCurrentRoute();
    const g = groupOf(page);
    btns.forEach((b) => b.classList.toggle('on', !!g && b.dataset.group === g.id));
    placeHl(g ? groupBtn(g.id) : null);
  }

  // ── popover ──
  let popTimer = null, popFor = null;
  function openPop(btn) {
    const g = groups.find((x) => x.id === btn.dataset.group); if (!g) return;
    const rec = _rec(g.id);
    pop.innerHTML = `<div class="ph"><span>${esc(g.label)}</span><button class="all" data-all>Ver tudo</button></div>` +
      g.items.map((it) => `<button class="pi" role="menuitem" data-page="${it.page}" data-gid="${g.id}">${_ico(it.icon)}${esc(it.label)}${it.page === rec ? '<span class="rec">recente</span>' : ''}</button>`).join('');
    const br = btn.getBoundingClientRect(), ir = ilha.getBoundingClientRect();
    pop.style.left = Math.max(8, Math.min(innerWidth - 240, br.left + br.width / 2 - 112)) + 'px';
    pop.style.bottom = (innerHeight - ir.top + 14) + 'px';
    pop.classList.add('open'); ilha.classList.add('pop-open'); popFor = btn;
  }
  function closePop() { pop.classList.remove('open'); ilha.classList.remove('pop-open'); popFor = null; }
  ilha.addEventListener('mouseover', (e) => {
    const btn = e.target.closest('.ilha-btn');
    clearTimeout(popTimer);
    if (!btn || !btn.dataset.group) { if (!pop.matches(':hover')) popTimer = setTimeout(closePop, 220); return; }
    if (popFor === btn) return;
    popTimer = setTimeout(() => openPop(btn), 300);
  });
  ilha.addEventListener('mouseleave', () => { clearTimeout(popTimer); popTimer = setTimeout(closePop, 260); });
  pop.addEventListener('mouseenter', () => clearTimeout(popTimer));
  pop.addEventListener('mouseleave', () => { popTimer = setTimeout(closePop, 220); });
  ilha.addEventListener('contextmenu', (e) => {
    const btn = e.target.closest('.ilha-btn');
    if (btn && btn.dataset.group) { e.preventDefault(); popFor === btn ? closePop() : openPop(btn); }
  });
  pop.addEventListener('click', (e) => {
    if (e.target.closest('[data-all]')) { e.stopPropagation(); const gl = pop.querySelector('.ph span')?.textContent || ''; closePop(); openLaun(gl); return; }
    const pi = e.target.closest('.pi'); if (!pi) return;
    _rec(pi.dataset.gid, pi.dataset.page); closePop(); navigate(pi.dataset.page);
  });

  // ── launcher = HUB da Busca IA (fusão 04/07) ──
  function openLaun(query) {
    import('../components/topbar.js').then(({ openBuscaHub }) => openBuscaHub(query)).catch(() => {});
  }
  function closeLaun() {}

  // ── clique na ilha (trava anti-spam na animação; navegação instantânea) ──
  let tapLock = false;
  ilha.addEventListener('click', (e) => {
    const btn = e.target.closest('.ilha-btn'); if (!btn) return;
    if (!tapLock) {
      tapLock = true; btn.classList.add('pop');
      const unlock = () => { btn.classList.remove('pop'); tapLock = false; };
      btn.addEventListener('animationend', unlock, { once: true });
      setTimeout(unlock, 360);
    }
    if (btn.dataset.apps) { e.stopPropagation(); openLaun(''); return; }
    const g = groups.find((x) => x.id === btn.dataset.group); if (!g) return;
    closePop();
    const dest = _rec(g.id) && g.items.some((i) => i.page === _rec(g.id)) ? _rec(g.id) : g.items[0].page;
    _rec(g.id, dest); navigate(dest);
  });

  // ── reativa: mini no scroll (captura — o scroller do admin é interno) ──
  const scrollState = new WeakMap();
  const onScroll = (e) => {
    const el = e.target === document ? (document.scrollingElement || document.documentElement) : e.target;
    if (!el || typeof el.scrollTop !== 'number') return;
    const last = scrollState.get(el) ?? el.scrollTop;
    const t = el.scrollTop;
    if (t > last + 6 && t > 28) ilha.classList.add('mini');
    else if (t < last - 6) ilha.classList.remove('mini');
    if (Math.abs(t - last) > 6) syncActive();
    scrollState.set(el, t);
  };
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });

  // ── teclado + rota ──
  // Ctrl+K pertence à Busca IA da topbar (conflito detectado no teste 04/07) —
  // o launcher da ilha abre só pelo ⊞; fusão launcher × Busca IA é backlog.
  const onKey = (e) => {
    if (e.key === 'Escape') { closePop(); closeLaun(); }
  };
  addEventListener('keydown', onKey);
  const onHash = () => syncActive();
  addEventListener('hashchange', onHash);
  addEventListener('resize', syncActive);
  requestAnimationFrame(syncActive);

  _state = {
    destroy() {
      document.removeEventListener('scroll', onScroll, { capture: true });
      removeEventListener('keydown', onKey); removeEventListener('hashchange', onHash); removeEventListener('resize', syncActive);
      wrap.remove(); pop.remove();
      document.body.classList.remove('ilha-on');
      _state = null;
    },
  };
  return _state;
}

export function unmountIlha() { if (_state) _state.destroy(); }
export default mountIlha;
